import React from 'react';

const NotFound: React.FC = () => {
    // Set page title for 404 page
    React.useEffect(() => {
        document.title = 'Proposal Not Found - Cinch';
    }, []);

    return (
        <div className="min-h-screen bg-gradient-to-br from-cinch-light to-white flex flex-col items-center justify-center px-4">
            <div className="max-w-md w-full text-center animate-fade-in">
                <div className="mb-8">
                    <img 
                        src="https://cleancinch.com/wp-content/uploads/2025/05/aa836ec1-54ef-4339-9b94-8b6eec324faa.png" 
                        alt="Cinch Logo" 
                        className="h-16 w-auto mx-auto mb-4"
                    />
                </div>
                
                <div className="mb-6">
                    <div className="inline-flex items-center justify-center w-24 h-24 bg-cinch-primary rounded-full mb-4">
                        <svg className="w-12 h-12 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                        </svg>
                    </div>
                </div>

                <h1 className="text-4xl font-bold text-cinch-primary mb-4">
                    Document Not Found
                </h1>
                
                <p className="text-lg text-gray-600 mb-6 leading-relaxed">
                    The proposal you're looking for doesn't exist or may have expired. 
                    Please check your link or contact the sender for assistance.
                </p>

                <div className="bg-white rounded-lg shadow-lg p-6 border border-gray-100">
                    <h3 className="text-lg font-semibold text-cinch-primary mb-3">Need Help?</h3>
                    <p className="text-gray-600 text-sm mb-4">
                        If you believe this is an error, please contact our support team.
                    </p>
                    <a 
                        href="mailto:support@cleancinch.com" 
                        className="inline-flex items-center justify-center px-4 py-2 bg-cinch-primary text-white rounded-lg hover:bg-cinch-secondary transition-colors duration-200 text-sm font-medium"
                    >
                        Contact Support
                    </a>
                </div>
            </div>
        </div>
    );
};

export default NotFound;